export type WorkFormCreateTab = 'single-day' | 'multi-day';

export type MultiDayDayBlock = {
  date: string;
  startTime: string;
  endTime: string;
  breakMinutes: string | undefined;
};

export type MultiDayWorkFormContext = {
  createTab: WorkFormCreateTab;
  multiDayDates: string[];
  multiDayDayBlocks: MultiDayDayBlock[];
};

export const MULTI_DAY_WORK_FORM_FIELDS = {
  createTab: 'createTab',
  multiDayDates: 'multiDayDates',
  multiDayDayBlocks: 'multiDayDayBlocks',
} as const satisfies Record<keyof MultiDayWorkFormContext, keyof MultiDayWorkFormContext>;
